
import { useActiveDatabaseContext } from '../Components/ActiveDatabaseContext/ActiveDatabaseContextUtils';
import { useMDDetailSelectionContext } from '../Components/MasterDetail/Contexts/MdDetailSelectionContext';
import { useDeleteMutation } from '../Components/ObjectMenu/DeleteMutation';
import { IBusinessConfig } from '../Features/Delsystem/_Common/Const/BusinessConfigs';
import {
  IFunctionMenuItem,
  IUseItemFunctionMenuItemsTypeInput,
} from '../Utils/ObjektVyUtils';

export const useDeleteFunctionMenuItem = (
  input: IUseItemFunctionMenuItemsTypeInput,
  businessConfig?: IBusinessConfig
): IFunctionMenuItem => {
  const SBLabel = input.collection.RootType.SBLabel.toLowerCase();
  const SOLabel = input.collection.RootType.SOLabel.toLowerCase();
  const confirmationDetaljer = input && input.item && input.item['IDString'];

  const deleteItem = useDeleteItem(input);
  const deleteable = businessConfig?.itemDeletable
    ? businessConfig.itemDeletable(input)
    : { disabled: false, disabledReason: undefined };

  return {
    caption: input.item?.['BORTTAGEN'] ? 'Ångra borttag' : 'Ta bort',
    id: 'DELETE_ITEM',
    disabled: deleteable.disabled,
    disabledReason: deleteable.disabledReason,
    hidden: !businessConfig?.userDeleteable,
    iconType: 'delete',
    onClick: deleteItem,
    confirmButtonCaption: 'Ta bort',
    confirmDialogCaption: `Ta bort ${SOLabel}`,
    confirmDialogMessage: `Vill du ta bort ${SBLabel} ${confirmationDetaljer}?`,
  };
};

export const useDeleteItem = (
  input: IUseItemFunctionMenuItemsTypeInput
): React.DispatchWithoutAction => {
  const { activeDatabase } = useActiveDatabaseContext();
  const { unselectDetail } = useMDDetailSelectionContext();
  const action = input.item?.['BORTTAGEN'] ? 'Undelete' : 'Delete';
  const deleteMutation = useDeleteMutation(
    {
      id: input.id,
      collectionName: input.collection?.CollectionName,
      dbName: activeDatabase ?? undefined,
      version: input?.item?._version,
    },
    action
  );
  return () => {
    deleteMutation();
    if (action === 'Delete') {
      unselectDetail?.();
    }
  };
};
